import { WarningIcon } from 'assets/img/icons/warning';
import React, { Dispatch, SetStateAction } from 'react';
import { Button } from 'components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
} from 'components/ui/dialog';

interface IProps {
  showModal: boolean;
  setShowModal: Dispatch<SetStateAction<boolean>>;
  deleteDevice: (id: string) => void;
  deviceId: string;
  deviceName: string;
}
const DeleteDevice = ({
  setShowModal,
  showModal,
  deleteDevice,
  deviceId,
  deviceName,
}: IProps): JSX.Element => {
  return (
    <Dialog open={showModal} onOpenChange={setShowModal}>
      <DialogContent className="max-w-sm" data-testid="delete-device-modal">
        <div className="flex items-start gap-3">
          <WarningIcon viewBox="0 0 32 32" aria-hidden="true" />
          <div>
            <h2 className="mb-2 text-xl font-semibold text-gray-blue-90">Delete payment device?</h2>
            <span className="text-sm text-gray-blue-70">
              Are you sure you want to delete this{' '}
              <span className="font-semibold"> {deviceName} </span>{' '}
              payment device?
            </span>
          </div>
        </div>
        <DialogFooter className="flex gap-2">
          <Button variant="outline" onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button
            data-testid="deleteCTA"
            onClick={() => deleteDevice(deviceId)}
            variant="destructive"
          >
            Delete payment device
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteDevice;
